import React, {useState, useEffect} from 'react';
import MyWebWorker from './statusWebWorker.worker';
import { ReactReader } from 'react-reader'
//import Axios from 'axios'

interface MyComponentProps {
  //list?: string
  tresourceid: string
  viewerHeight?: string // 100vh 1000px etc
  useCache?: boolean
  format?: string // pdf or epub
  
}

export const PrintView: React.FC<MyComponentProps> = (props) => {
  const [pdfStatus, setPdfStatus] = useState<any>({status: "Starting", pdf: ""})
  const useCache = props.useCache !== undefined ? props.useCache : true;
  const format = props.format !== undefined ? props.format : "pdf";
  const [location, setLocation] = useState<string | number>(0)
  

  const list = [
    {
      "@context": "http://www.w3.org/ns/anno.jsonld",
      "body": {
        "type": "TextualBody",
        "value": ""
      },
      "created": "2022-09-03T18:18:20.131Z",
      "creator": "http://scta.info/resource/jeffreycwitt",
      "id": "http://inbox.scta.info/notifications/temporary/1",
      "motivation": "commenting",
      "target": {
        "esource": "http://scta.info/resource/" + props.tresourceid.split("/resource/")[1].split("/")[0],
        "selector": [
          {
            "exact": "",
            "type": "TextQuoteSelector"
          },
          {
            "end": "",
            "start": "",
            "type": "TextPositionSelector"
          }
        ],
        "source": props.tresourceid
      },
      "type": "Annotation"
    },
  ]
  useEffect(() => {
    //handleGetPdfStatus()
    const printApiEndpoint = "https://print.lombardpress.org/api/v1/";
    //const printApiEndpoint = "http://localhost:5000/api/v1/";
    const worker = new Worker(new URL('./statusWebWorker.ts', import.meta.url));

    worker.postMessage({ printApiEndpoint, list, useCache, format });

    worker.onmessage = function (e) {
      const { status, pdf } = e.data;
      setPdfStatus({ status, pdf });
    };

    return () => {
      worker.terminate();
    };
  }, [props.tresourceid])
  
 

// return(
//   <div className="print-view-container" style={{"height": props?.viewerHeight || "100vh"}}>
//      {
//      pdfStatus.pdf 
//      ? (
//     <object data={pdfStatus.pdf} type="application/pdf" style={{"height": "100%", "width": "100%"}}>
//               alt : <a href={pdfStatus.pdf}>{pdfStatus.pdf}</a>
//             </object> )

     
//      :
//      <p><span>{pdfStatus.status}</span></p>
//     }
//   </div>
// )
return (
  <div className="print-view-container" style={{ height: props?.viewerHeight || "100vh" }}>
    {pdfStatus.pdf ? (
      pdfStatus.pdf.endsWith('.epub') ? (
        <>
       <ReactReader
        url={pdfStatus.pdf}
        location={location}
        locationChanged={(epubcfi: string) => setLocation(epubcfi)}
      />
      <span><a href={pdfStatus.pdf}>Download Epub</a></span>
      </>
      ) : (
        <>
        <object data={pdfStatus.pdf} type="application/pdf" style={{ height: "100%", width: "100%" }}>
          alt : <a href={pdfStatus.pdf}>{pdfStatus.pdf}</a>
        </object>
        <p><a href={pdfStatus.pdf}>Download Pdf</a></p>
        </>
      )
    ) : (
      <p><span>{pdfStatus.status}</span></p>
    )}
  </div>
);
}
